var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 7.3186C2.5 4.55718 4.73858 2.3186 7.5 2.3186H17.5C20.2614 2.3186 22.5 4.55718 22.5 7.3186V17.3186C22.5 20.08 20.2614 22.3186 17.5 22.3186H7.5C4.73858 22.3186 2.5 20.08 2.5 17.3186V7.3186ZM17.5 12.3186C17.5 15.08 15.2614 17.3186 12.5 17.3186C9.73858 17.3186 7.5 15.08 7.5 12.3186C7.5 9.55718 9.73858 7.3186 12.5 7.3186C15.2614 7.3186 17.5 9.55718 17.5 12.3186ZM18.5 7.3186C19.0523 7.3186 19.5 6.87088 19.5 6.3186C19.5 5.76632 19.0523 5.3186 18.5 5.3186C17.9477 5.3186 17.5 5.76632 17.5 6.3186C17.5 6.87088 17.9477 7.3186 18.5 7.3186ZM15.5 12.3186C15.5 13.9755 14.1569 15.3186 12.5 15.3186C10.8431 15.3186 9.5 13.9755 9.5 12.3186C9.5 10.6617 10.8431 9.3186 12.5 9.3186C14.1569 9.3186 15.5 10.6617 15.5 12.3186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.83fb9bd06c4d1708ddd90ea4339f2578.svg";
export { ForwardRef as ReactComponent };